export const mockResponse = {
  flowInstanceId: '0dcc477c-da68-42dd-8d0b-8dbe6f7a0471',
  messages: []
}
